import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import { useAuthStore } from '../../../../store';

const NameColumn = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const userProfile = useAuthStore((state) => state.userProfile);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Group gap={'xs'}>
                <Text>{rowData.name}</Text>
                {rowData.user?.value !== userProfile.id ? (
                    <Badge size={'xs'}>{rowData.user?.label || 'admin'}</Badge>
                ) : null}
            </Group>
        </Box>
    );
};

const Column = () => ({
    accessorKey: 'name',
    header: 'Name',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NameColumn cell={cell} />,
});
export default Column;
